import { styled } from '@mui/material/styles';

const TagTableCellContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

export default TagTableCellContainer;
